function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.223 6.13c0-3.386 2.686-6.13 6-6.13 3.313 0 6 2.744 6 6.13 0 1.334-.418 2.57-1.127 3.576l-.002.003-4.465 6.084a.501.501 0 01-.813 0L3.352 9.709l-.003-.003A6.194 6.194 0 012.223 6.13zm6 2.87a3 3 0 100-6 3 3 0 000 6z"
});

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgLocation;